import { render, staticRenderFns } from "./Purchases.vue?vue&type=template&id=600cf110&"
import script from "./Purchases.vue?vue&type=script&lang=js&"
export * from "./Purchases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src469726766/src/admin-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('600cf110')) {
      api.createRecord('600cf110', component.options)
    } else {
      api.reload('600cf110', component.options)
    }
    module.hot.accept("./Purchases.vue?vue&type=template&id=600cf110&", function () {
      api.rerender('600cf110', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/Purchases.vue"
export default component.exports